export default __webpack_public_path__ + "static/media/woman.e37ccee1.ogg";